import encodeFormData from '../../utilities/js/encodeFormData/encodeFormData.js';

let service;

class Cart {
  constructor() {
    this.urls = window.__globalConfig.apiUrls.productPage;
  }

  removeSingleProduct(requestData) {
    let encodedBody = encodeFormData(requestData);

    return fetch(`/basket/remove/?${encodedBody}`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
    }).then((response) => {
      if (response.status === 200 || response.ok) {
        return response.json();
      }
    });
  }

  changeQuantity(data) {
    data[window.__globalConfig.csrfToken.name] = window.__globalConfig.csrfToken.value;
    return fetch(this.urls.edit, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      body: encodeFormData(data)
    })
        .then(response => {
          if (response.redirected) {
            location.href = response.url;
          }
          return response.json();
        });
  }

  addPromoItem(data) {
    data.data[window.__globalConfig.csrfToken.name] = window.__globalConfig.csrfToken.value;
    return fetch(data.url, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      body: encodeFormData(data.data)
    })
        .then(response => {
          return response.json();
        });
  }
}

function cart() {
  if (service) {
    return service;
  } else {
    service = new Cart();
    return service;
  }
}

export default cart;
